import "core-js/modules/es.array.map.js";
import $ from 'jquery';
import { uploadImg } from '@/api/mg';
export default {
  data: function data() {
    return {
      opacity: 0,
      title: '',
      content: '',
      type: '1',
      fileList: []
    };
  },
  mounted: function mounted() {
    this.$nextTick(function () {
      // $('.content').height($(window).height() - $('.titleBar').height() - $('.toolbar').height() - $('.upload-con').height() - $('.bottom').height())
    });
  },
  methods: {
    onOversize: function onOversize() {
      this.$toast('文件过大');
    },
    del: function del(file) {
      this.opacity = 0;
      console.log(this.fileList, 'this.fileList');
    },
    afterRead: function afterRead(file) {
      var _this = this;
      this.opacity = 1;
      // 此时可以自行将文件上传至服务器
      if (file instanceof Array) {
        // 判断是否是数组
        file.map(function (item) {
          var formData = new FormData();
          formData.append('file', item.file);
          formData.append('type', _this.type);
          item.status = 'uploading';
          item.message = 'uploading...';
          uploadImg(formData).then(function (res) {
            if (res.Code === 0) {
              item.id = res.Data.id;
              item.status = 'done';
              item.message = 'success';
            } else {
              item.status = 'failed';
              item.message = 'failed';
            }
          }).catch(function () {
            item.status = 'failed';
            item.message = 'failed';
          });
        });
      } else {
        var formData = new FormData();
        formData.append('file', file.file);
        formData.append('type', this.type);
        file.status = 'uploading';
        file.message = 'uploading...';
        uploadImg(formData).then(function (res) {
          if (res.Code === 0) {
            file.id = res.Data.id;
            console.log(_this.fileList, 'this.fileList');
            file.status = 'done';
            file.message = 'success';
          } else {
            file.status = 'failed';
            file.message = 'failed';
          }
        }).catch(function () {
          file.status = 'failed';
          file.message = 'failed';
        });
      }
      // this.fileList.forEach((item) => {
      // const params = { type: 1, file: file.file }
      // uploadImg(formData).then((res) => {
      //   if (res.Code === 0) {
      //     console.log(res.Data)
      //     console.log(this.fileList, 'this.fileList')
      //   } else {
      //     this.$toast(res.Message)
      //   }
      // })
      // })
    },
    updateData: function updateData() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      this.content = e;
    },
    publish: function publish() {
      console.log(this.content);
    },
    back: function back() {
      var _this2 = this;
      var timer = setTimeout(function () {
        _this2.$router.back();
        clearTimeout(timer);
      }, 100);
    }
  }
};